import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const testimonialsSlider = document.querySelector('.testimonials-slider');

export default function initTestimonialsSlider() {
    if (testimonialsSlider) {
        // eslint-disable-next-line no-new
        new Swiper('.testimonials-slider', {
            direction: 'horizontal',
            loop: true,
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
}
